import React from "react";
import pic from "../../assets/lab/cselab1-1.jpg";

const Counseling = () => {
  return (
    <div>
      <div class="navbar navbar-expand-lg navbar-dark " style={{ backgroundColor: "#2C268A" }}
      >
        <div class="container">
          <a class="navbar-brand" href="#">
            COUNSELLING
          </a>
        </div>
      </div>
      <br />

      <div className="container h-100">
        <div className=" ">
          <img
            className="img-fluid rounded  "
            src={pic}
            alt="img-img"
            style={{ height: "600px",
          width:"100%" }}
          />
        </div>
      </div>
      <br />

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: "100px" }}
            >
              <div className="position-relative h-100">
                <p style={{textAlign:"justify"}}>
                <p>
                  SSIT offers confidential and free professional counselling and
                  psychological support to its students by staff in order to
                  help them in handling various stressful situations and to cope
                  up with their problems for their better social adjustment and
                  good professional performance. This enables them to take full
                  advantage of the academic and social environment of the
                  college and realize their potential to the fullest extent.
                </p>
                <p>
                  All teaching staff are designated as counsellors for 20
                  students, who listen to the issues of the students and hold
                  one-to-one counselling sessions for solving their problems.
                </p>
                </p>
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h5 className="section-title text-start  pe-3" style={{  Color: "#2C268A" }}
>
              Counselling and Support is provided in the Following Area
              </h5>
              <p>
             <p> Personal adjustment problems</p>
              
             <p> Situational crises</p>
             <p> Communication skills</p>
              <p>Regularity</p>
             <p> Learning skills for lifelong usage</p>
              <p>Academic stress</p>
              </p>

            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Counseling;
